// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/DroidSans-Bold-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/DroidSans-webfont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "droid_sansbold";
  src: local("DroidSans-Bold-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "droid_sansregular";
  src: local("DroidSans-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
}

ul[role=list],
ol[role=list] {
  list-style: none;
}

html:focus-within {
  scroll-behavior: smooth;
}

a:not([class]) {
  text-decoration-skip-ink: auto;
}

img,
picture,
svg,
video,
canvas {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  font-style: italic;
  background-repeat: no-repeat;
  background-size: cover;
}

input,
button,
textarea,
select {
  font: inherit;
}

@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
    transition: none;
  }
}
body,
html {
  height: 100%;
  scroll-behavior: smooth;
}

.analytics-filter {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}

.btn-bg-none {
  border: none;
}

.export-btn-container {
  display: flex;
  position: relative;
}

.save-table-btn {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1rem;
}

.table-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 12px;
  gap: 10px;
}

.form-control.weights-input {
  width: 120px;
}

.analytics-table tr:first-child {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  background-color: #fff;
}
.analytics-table tr:first-child span {
  color: #2f2f2f !important;
}

.filter-btn {
  position: relative;
}
.filter-btn .filter-table-btn {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 1rem;
}

.metric-name {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.metric-info {
  display: flex;
  position: relative;
}

.info-icon {
  display: flex;
  width: 12px;
  height: 12px;
  aspect-ratio: 1;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #0d47a0;
  margin: 0 6px;
  cursor: pointer;
  position: relative;
}

.metric-desc {
  position: absolute;
  display: block;
  width: 250px;
  padding: 8px 12px;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);
  top: 0;
  left: 105%;
  font-size: 13px;
  color: #888;
  white-space: normal;
}

.metric-desc::after {
  content: "";
  position: absolute;
  top: 15%;
  right: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent black transparent transparent;
}

.brand-category {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  display: block;
  font-size: 12px;
  color: #333;
  line-height: 1;
}

.comparision-table {
  width: 100%;
  table-layout: fixed;
}

.comparision-table thead {
  background-color: #f0f0f0;
  position: sticky;
  top: 0;
  z-index: 3;
}

@media (max-width: 767px) {
  .analytics-filter {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  .Select-input {
    width: 100% !important;
    max-width: 330px;
  }
  .export-btn {
    white-space: nowrap;
  }
  .analytics-select .multi-select-dropdown {
    width: 100%;
    max-width: 100%;
    min-width: 90%;
  }
}
.section-header,
.platform-header {
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-sizes {
  font-size: 16px;
}

.platform-name {
  display: flex;
  flex: 0.75 1;
}

.badge-text-size {
  background-color: lightgrey;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/mixins/fonts.scss","webpack://./src/pages/analytics/analytics.scss","webpack://./src/assets/mixins/reset.scss","webpack://./src/assets/mixins/mixins.scss","webpack://./src/assets/mixins/colors.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,oGAAA;EAEA,mBAAA;EACA,kBAAA;ACAF;ADEA;EACE,gCAAA;EACA,+FAAA;EAEA,mBAAA;EACA,kBAAA;ACDF;ACbA;;;EAGE,sBAAA;ADeF;;ACZA;EACE,SAAA;EACA,UAAA;ADeF;;ACZA;;EAEE,gBAAA;ADeF;;ACZA;EACE,uBAAA;ADeF;;ACZA;EACE,8BAAA;ADeF;;ACZA;;;;;EAKE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;ADeF;;ACZA;;;;EAIE,aAAA;ADeF;;ACZA;EACE;IACE,qBAAA;EDeF;ECbA;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;IACA,gBAAA;EDeF;AACF;ACZA;;EAEE,YAAA;EACA,uBAAA;ADcF;;AA1EA;EECE,sBCCM;EDAN,qBAAA;EACA,wCAAA;EFDA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AA+EF;;AA7EA;EACE,YAAA;AAgFF;;AA9EA;EACE,aAAA;EACA,kBAAA;AAiFF;;AA/EA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;AAkFF;;AAhFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAmFF;;AAjFA;EACE,YAAA;AAoFF;;AAjFE;EDLA,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECIE,sBG/BI;AHsHR;AAtFI;EACE,yBAAA;AAwFN;;AApFA;EACE,kBAAA;AAuFF;AAtFE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,SAAA;AAwFJ;;AArFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAwFF;;AAtFA;EACE,aAAA;EACA,kBAAA;AAyFF;;AAvFA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cGxEc;EHyEd,aAAA;EACA,eAAA;EACA,kBAAA;AA0FF;;AAvFA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EE/EA,sBCCM;EDAN,qBAAA;EACA,wCAAA;EF+EA,MAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AA4FF;;AA1FA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uDAAA;AA6FF;;AA1FA;ED/EE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EC8EA,cAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;AAgGF;;AA7FA;EACE,WAAA;EACA,mBAAA;AAgGF;;AA7FA;EACE,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAgGF;;AA7FA;EACE;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EAgGF;EA3FA;IACE,sBAAA;IACA,gBAAA;EA6FF;EA3FA;IACE,mBAAA;EA6FF;EA3FA;IACE,WAAA;IACA,eAAA;IACA,cAAA;EA6FF;AACF;AA3FA;;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;AA6FF;;AA3FA;EACE,eAAA;AA8FF;;AA5FA;EACE,aAAA;EACA,YAAA;AA+FF;;AA5FA;EACE,2BAAA;EAEA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA8FF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\r\n@font-face {\r\n  font-family: \"droid_sansbold\";\r\n  src: local(\"DroidSans-Bold-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: \"droid_sansregular\";\r\n  src: local(\"DroidSans-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@mixin primeFont() {\r\n  font-family: \"Abril Fatface\", serif;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFont() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFontBold() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n}\r\n","@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@font-face {\n  font-family: \"droid_sansbold\";\n  src: local(\"DroidSans-Bold-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"droid_sansregular\";\n  src: local(\"DroidSans-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n}\n\nul[role=list],\nol[role=list] {\n  list-style: none;\n}\n\nhtml:focus-within {\n  scroll-behavior: smooth;\n}\n\na:not([class]) {\n  text-decoration-skip-ink: auto;\n}\n\nimg,\npicture,\nsvg,\nvideo,\ncanvas {\n  max-width: 100%;\n  height: auto;\n  vertical-align: middle;\n  font-style: italic;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html:focus-within {\n    scroll-behavior: auto;\n  }\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n    transition: none;\n  }\n}\nbody,\nhtml {\n  height: 100%;\n  scroll-behavior: smooth;\n}\n\n.analytics-filter {\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 1rem;\n}\n\n.btn-bg-none {\n  border: none;\n}\n\n.export-btn-container {\n  display: flex;\n  position: relative;\n}\n\n.save-table-btn {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding-top: 1rem;\n}\n\n.table-buttons {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 12px;\n  gap: 10px;\n}\n\n.form-control.weights-input {\n  width: 120px;\n}\n\n.analytics-table tr:first-child {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  background-color: #fff;\n}\n.analytics-table tr:first-child span {\n  color: #2f2f2f !important;\n}\n\n.filter-btn {\n  position: relative;\n}\n.filter-btn .filter-table-btn {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  align-items: baseline;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n.metric-name {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.metric-info {\n  display: flex;\n  position: relative;\n}\n\n.info-icon {\n  display: flex;\n  width: 12px;\n  height: 12px;\n  aspect-ratio: 1;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0d47a0;\n  margin: 0 6px;\n  cursor: pointer;\n  position: relative;\n}\n\n.metric-desc {\n  position: absolute;\n  display: block;\n  width: 250px;\n  padding: 8px 12px;\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);\n  top: 0;\n  left: 105%;\n  font-size: 13px;\n  color: #888;\n  white-space: normal;\n}\n\n.metric-desc::after {\n  content: \"\";\n  position: absolute;\n  top: 15%;\n  right: 100%;\n  margin-top: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent black transparent transparent;\n}\n\n.brand-category {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  display: block;\n  font-size: 12px;\n  color: #333;\n  line-height: 1;\n}\n\n.comparision-table {\n  width: 100%;\n  table-layout: fixed;\n}\n\n.comparision-table thead {\n  background-color: #f0f0f0;\n  position: sticky;\n  top: 0;\n  z-index: 3;\n}\n\n@media (max-width: 767px) {\n  .analytics-filter {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n  .Select-input {\n    width: 100% !important;\n    max-width: 330px;\n  }\n  .export-btn {\n    white-space: nowrap;\n  }\n  .analytics-select .multi-select-dropdown {\n    width: 100%;\n    max-width: 100%;\n    min-width: 90%;\n  }\n}\n.section-header,\n.platform-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.icon-sizes {\n  font-size: 16px;\n}\n\n.platform-name {\n  display: flex;\n  flex: 0.75;\n}\n\n.badge-text-size {\n  background-color: lightgrey;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}","*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul[role=\"list\"],\r\nol[role=\"list\"] {\r\n  list-style: none;\r\n}\r\n\r\nhtml:focus-within {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\na:not([class]) {\r\n  text-decoration-skip-ink: auto;\r\n}\r\n\r\nimg,\r\npicture,\r\nsvg,\r\nvideo,\r\ncanvas {\r\n  max-width: 100%;\r\n  height: auto;\r\n  vertical-align: middle;\r\n  font-style: italic;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n  font: inherit;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  html:focus-within {\r\n    scroll-behavior: auto;\r\n  }\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n    scroll-behavior: auto !important;\r\n    transition: none;\r\n  }\r\n}\r\n\r\nbody,\r\nhtml {\r\n  height: 100%;\r\n  scroll-behavior: smooth;\r\n}\r\n","@import \"variables\", \"colors\", \"fonts\", \"reset\";\r\n\r\n@mixin boxWithShadow() {\r\n  background-color: $white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 13%);\r\n}\r\n@mixin brandScores() {\r\n  background-color: $white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 12%);\r\n  padding: 0.675rem;\r\n}\r\n\r\n@mixin pageTitle() {\r\n  @include primeFont();\r\n  font-size: 2rem;\r\n  color: $primary-color;\r\n  line-height: 2.5rem;\r\n  margin-top: 0.5rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n@mixin boxSubTitle() {\r\n  @include secondaryFontBold;\r\n  font-size: 1rem;\r\n  color: $text-color;\r\n  line-height: 1.2;\r\n  margin-bottom: .875rem;\r\n  display: flex;\r\n}","$primary-color: #0d47a0;\r\n$primary-color-hover: #093373;\r\n$secondary-blue: #93cfff;\r\n$background-color: #f4f6fa;\r\n$white: #fff;\r\n$text-color: #2f2f2f;\r\n$text-dark-color: #072148;\r\n$table-stroke-color: #dfdfdf;\r\n$stroke-color: #949494;\r\n$input-stroke: #e4e8e9;\r\n$text-warning: #ed8b00;\r\n$text-danger: #cc3201;\r\n$text-success: #339900;\r\n$tooltip-bg: #0d47a0;\r\n$tooltip-color: #ffffff;\r\n$button-color: #ff6b00;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
